import { ILanguageImplementation } from '../languageBundle';

export const GERMAN_TEXTS: ILanguageImplementation = {
  'de-DE': {
    DashboardTitle: 'Der Title des Dashboards',
    NavbarTitle: 'Inventar Verwaltung',
  },
};
